export const BLOG_POSTS = {
  "ges-termal-denetim-rehberi-2026": {
    slug: "ges-termal-denetim-rehberi-2026",
    title: "GES Termal Denetim Rehberi 2026: Yasal Yükümlülükler ve En İyi Uygulamalar",
    description:
      "50 kWp+ GES tesisleri için zorunlu termal denetim — yasal çerçeve, hot-spot tespit yöntemleri, drone vs. sürekli izleme karşılaştırması ve maliyet analizi.",
    date: "2026-01-14",
    readTime: "8 dk",
    category: "GES & Yenilenebilir Enerji",
    keywords:
      "ges termal denetim, hot spot tespiti, fotovoltaik termografi, TSE termal kontrol, ges yangın güvenliği",
    cover:
      "https://images.pexels.com/photos/8853509/pexels-photo-8853509.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    excerpt:
      "Türkiye'deki 50 kWp üstü her GES tesisi, TSE standartlarına göre yılda en az 2 kez termal denetim yaptırmak zorunda. Ancak yıllık denetim 4-6 ay sonra ortaya çıkan arızaları yakalayamaz...",
    sections: [
      {
        h2: "Türkiye'de GES Termal Denetim Yasal Çerçevesi",
        body:
          "Türk Standartları Enstitüsü (TSE) ve EPDK düzenlemelerine göre, 50 kWp ve üzeri tüm güneş enerji santrallerinde yılda en az 2 kez termal denetim yapılması zorunludur. Bu denetimler IEC 62446-3 standardı çerçevesinde gerçekleştirilir. Otel ve AVM çatı GES'leri yangın güvenliği yönetmeliği gereği ek olarak sürekli izleme yükümlülüğü taşır. Denetimsiz tesislere kurum tarafından ceza-i yaptırım uygulanabilir ve sigorta hasarlarında karşılanmama riski oluşur.",
      },
      {
        h2: "Hot-Spot Nedir, Neden Önemli?",
        body:
          "Hot-spot, güneş panelindeki bir hücrenin diğerlerinden anormal düzeyde yüksek sıcaklığa ulaşması durumudur. Sebepler arasında hücre çatlağı, lehim hatası, gölgeleme, bypass diyot arızası ve toz/kuş pisliği birikimi yer alır. Hot-spot panel verimini %5-15 düşürür, panel ömrünü kısaltır ve nadiren yangına yol açar. Çıplak gözle tespit edilemez; tek güvenilir yöntem termal görüntülemedir.",
      },
      {
        h2: "Drone vs. Sürekli Termal İzleme",
        body:
          "Drone termal denetimi yılda 1-2 kez detaylı tarama sağlar; geniş arazilerde maliyet-etkilidir. Ancak periyodik olduğu için iki denetim arasında oluşan hot-spotları kaçırır. Sürekli termal izleme (sabit kamera) 7/24 tarama yapar, arıza oluştuğu an alarm üretir; tek tek panel detayı drone kadar yüksek değildir. **En iyi uygulama:** ZAKE'nin önerisi her iki yöntemin kombinasyonudur — sürekli izleme + yılda 1 drone detay denetimi.",
      },
      {
        h2: "Maliyet & ROI Analizi",
        body:
          "1 MWp arazi GES için sürekli termal izleme yatırımı tipik olarak ₺180-350K arasındadır. Yıllık kazanım: %5-15 verim kaybı önleme (10-50K TL/yıl), yangın hasar prim indirimi (%10-25 sigorta primi tasarrufu), yasal denetim ücretlerinden tasarruf (₺15-40K/yıl). Tipik geri ödeme süresi 18-36 aydır.",
      },
      {
        h2: "Sonuç",
        body:
          "GES yatırımının korunmasında termal denetim opsiyonel değil zorunluluk. ZAKE'nin yapay zeka destekli çift spektrum sistemi, yasal yükümlülüğü otomatik karşılarken yatırım getirinizi optimize eder. Tesisiniz için detaylı saha analizi talep edebilirsiniz.",
      },
    ],
  },

  "kestirimci-bakim-termal-kamera-nedir": {
    slug: "kestirimci-bakim-termal-kamera-nedir",
    title: "Kestirimci Bakım Termal Kamera ile Nasıl Yapılır?",
    description:
      "Endüstriyel tesislerde kestirimci bakım (predictive maintenance) termal görüntüleme ile %70-85 plansız duruş azalması ve %40 bakım tasarrufu nasıl sağlanır?",
    date: "2026-01-13",
    readTime: "10 dk",
    category: "Endüstriyel Bakım",
    keywords:
      "kestirimci bakım, predictive maintenance, termal kamera bakım, motor termal izleme, MCC termal, rulman aşınması",
    cover:
      "https://images.unsplash.com/photo-1720036236697-018370867320?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxkYXJrJTIwZmFjdG9yeSUyMG1hY2hpbmVyeXxlbnwwfHx8fDE3ODE0NTU1NDh8MA&ixlib=rb-4.1.0&q=85",
    excerpt:
      "Endüstri 4.0 dünyasında reaktif bakım artık yetersiz. Kestirimci bakım, arızaları oluşmadan tahmin eden veri tabanlı bir yaklaşımdır. Termal görüntüleme bu yaklaşımın omurgasıdır...",
    sections: [
      {
        h2: "Reaktif, Önleyici ve Kestirimci Bakım Farkı",
        body:
          "Reaktif bakım: ekipman bozulunca tamir. Önleyici bakım: takvime göre periyodik servis. Kestirimci bakım: ekipmanın gerçek zamanlı durumuna göre bakım kararı. Termal görüntüleme, kestirimci bakımın en güçlü teşhis araçlarından biridir; çünkü neredeyse tüm mekanik ve elektriksel arızalar sıcaklık değişimi ile sinyal verir.",
      },
      {
        h2: "Termal İzleme Hangi Arızaları Tahmin Eder?",
        body:
          "Elektriksel: bara/kablo gevşemesi, aşırı yüklenme, izolasyon arızası, harmonik dengesizlik. Mekanik: rulman aşınması, eksantriklik, yağsızlık, kayış-kasnak gerginlik problemi. Termal: yalıtım kaybı, kazan verim düşüşü, soğutucu kaçağı. Tipik olarak arızalar fiziksel hasara dönüşmeden 24-72 saat önceden termal imza verir.",
      },
      {
        h2: "Saha Sonuçları",
        body:
          "ZAKE referans tesisleri: %70-85 plansız duruş azalması, %40 bakım maliyet tasarrufu, %30-50 ekipman ömrü uzaması, %15-25 enerji verimliliği iyileşmesi. Yatırım geri dönüşü genelde 8-18 ay; tek bir önemli arızanın önlenmesi sistemin maliyetini karşılar.",
      },
      {
        h2: "Yapay Zeka ile Veri Yorumlama",
        body:
          "Eski termal sistemler sabit eşik değerleri kullanırdı (örn. 'pano 70°C üstünde alarm'). Bu yöntem yanlış alarm oranını yüksek tutuyordu. ZAKE'nin AI motoru her ekipman için 'normal sıcaklık imzası' öğrenir; saat/gün/sezon değişimlerini kontrol eder ve sadece istatistiksel anlamda anormal olaylar için alarm üretir.",
      },
    ],
  },

  "sera-termal-goruntuleme-precision-agriculture": {
    slug: "sera-termal-goruntuleme-precision-agriculture",
    title: "Sera Termal Görüntüleme: Bitki Stresinden Don Önlemeye Hassas Tarım",
    description:
      "Sera tarımında termal kamera kullanımı: yaprak sıcaklığı, su stresi tespiti, ısıtma sistemi izleme, don önleme — verim artışı %25'e kadar.",
    date: "2026-01-12",
    readTime: "9 dk",
    category: "Sera & Hassas Tarım",
    keywords:
      "sera termal kamera, bitki stresi, yaprak sıcaklığı, hassas tarım, precision agriculture, don önleme, sulama optimizasyonu",
    cover:
      "https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?auto=format&fit=crop&w=940&q=80",
    excerpt:
      "Domates serasında bir bitkinin yaprak sıcaklığı 2°C arttığında, bu bitkide su stresi başlamış demektir. Solma yapraklarda görülmeden günler önce... Termal kamera serayı 'görür gibi' okur.",
    sections: [
      {
        h2: "Yaprak Sıcaklığı Neden Önemli?",
        body:
          "Bitkiler stomalarından (yaprak gözenekleri) buharlaşma yoluyla soğurlar — bu süreç transpirasyon. Sağlıklı bitki yaprağı çevre sıcaklığından genellikle 1-3°C düşüktür. Su stresi başlayan bitki stomayı kapatır, transpirasyon durur, yaprak sıcaklığı artar. Termal kamera bu artışı solma görülmeden 2-7 gün önce algılar.",
      },
      {
        h2: "Hastalık ve Zararlı Erken Tespiti",
        body:
          "Patojenler bitkide metabolik anomaliye yol açar. Lokal sıcaklık değişimleri (bazı bölgelerde yükselme, bazı bölgelerde düşme) termal harita ile görülür. Akarın yoğun olduğu yapraklar, mantar enfeksiyonu başlayan dallar — semptom öncesi tespit edilir.",
      },
      {
        h2: "Isıtma Sistemi Verimliliği",
        body:
          "Modern seralarda ısıtma maliyeti toplam işletme giderlerinin %30-50'sini oluşturur. Termal kamera ile boyler, sıcak su boru hatları, eşanjör verimi ve sera içi sıcaklık dağılımı izlenir. Kaçaklar, tıkanmalar ve verim düşüşleri saniyeler içinde tespit edilir; %15-25 enerji tasarrufu sağlanır.",
      },
      {
        h2: "Don Önleme Otomasyonu",
        body:
          "Türkiye'de don zararı yıllık milyarlarca TL ürün kaybına yol açar. Termal kamera sera içi sıcaklığı m² bazında haritalar; kritik eşik altına düşen bölgelerde otomatik perde kapatma, fan, sıcak hava üfleme, ısıtıcı tetiklenir. Manuel müdahalenin geç kaldığı durumlarda ürün kurtarır.",
      },
      {
        h2: "Sulama Optimizasyonu",
        body:
          "Damlama sulama sistemlerinde tek bir emitör tıkanması metrekarelerce alanda su stresine yol açar. Termal harita kuru bölgeleri 2-4 saat içinde tespit eder; sulama optimizasyonu ile %15-30 su tasarrufu + verim artışı sağlanır.",
      },
      {
        h2: "Yatırım & ROI",
        body:
          "Orta ölçekli sera (5,000-15,000 m²) için tipik termal sistem yatırımı ₺120-300K. Verim artışı (%15-25) ve enerji tasarrufu birleşince ROI tipik olarak 12-24 ay. Ek olarak don önleme tek bir yıl başına yatırımı geri ödeyebilir.",
      },
    ],
  },
};

export const BLOG_SLUGS = Object.keys(BLOG_POSTS);
